export default __webpack_public_path__ + "static/media/Money_Coin_16_9.9be1b339.png";